import { payment3_commonpb } from "@ftdr/payment3_paymentmethod_coordinator-js-client";
import { WalletCheckboxValue } from "../types";
import Brand = payment3_commonpb.Brand;

type Props = {
  brand: payment3_commonpb.Brand;
  contractID?: string | null;
  customerID?: string | null;
  showWalletCheckbox?: WalletCheckboxValue;
};

export const allowedBrands = [
  Brand.HSA,
  Brand.AHS,
  Brand.FTDR,
  Brand.HBW210,
  Brand.FrontdoorPro,
];

export const validateProps = ({
  brand,
  contractID,
  customerID,
  showWalletCheckbox,
}: Props): boolean => {
  if (!allowedBrands.includes(brand)) {
    return false;
  }

  return !(
    showWalletCheckbox === WalletCheckboxValue.SET_AS_DEFAULT &&
    (!contractID || !customerID)
  );
};
